import type { CelebrityResult } from "./types";

export const patHoberg: CelebrityResult = {
  slug: "pat-hoberg",
  firstName: "Pat",
  lastName: "Hoberg",
  roleLines: ["Professional Baseball Umpire", "6,000 Grafts"],
  headlineLines: ["My Hairline is No Longer in", "Foul Territory!"],
  intro: [
    "Pat Hoberg made the right call and chose RESTORE® as the one for his hair restoration procedure. Pat Hoberg is a professional umpire for Major League Baseball, even having umpired a perfect game in the World Series.",
  ],
  heroBannerImage: {
    src: "/endorser-banners/hoberg_website_banner_1920x800_v1.webp",
    alt: "Pat Hoberg RESTORE hair restoration results banner",
  },
  heroBannerImageMobile: {
    src: "/endorser-banners/hoberg_website_mobile_800x879_v1.webp",
    alt: "Pat Hoberg RESTORE hair restoration results banner",
  },
  heroBackground: "/img/r/wp-2024-09-mlbumpireslifestyle-003.webp",
  heroLayout: "diagonal-right",
  heroBackgroundPosition: "86% center",
  heroMinHeight: "700px",

  posterImage: {
    src: "/img/r/wp-2024-09-mlbumpiresportraits-048-v2-2-1.webp",
    alt: "Pat Hoberg RESTORE Hair Results",
  },

  heroBeforeAfter: {
    src: "/img/r/wp-2024-09-pat-hoberg-before-img.webp",
    alt: "Pat Hoberg before hair transplant",
  },
  story: {
    video:
      "https://d17ehmrb6zqtjv.cloudfront.net/Videos/Videos+with+Captions/MLBUmpiresRESTOREHair.mp4",
    headingSuffix: "& MLB Umpires Get Back In The Game With Hair Transplants",
    paragraphs: [
      "Pat Hoberg made the right call and chose RESTORE® as the one for his hair restoration procedure. Patrick Hoberg is a professional Major League Baseball umpire, even having umpired a perfect game in the World Series.",
      "Making important, and sometimes stressful calls out on the field requires extreme confidence. When umpire Pat's hair started to thin, he knew it was time to make a change. As Hoberg puts it himself, \"Confidence is for sure a big deal out there because if a player senses weakness at all, they are going to pounce on you and make your job a lot harder.\" That's when he came to RESTORE as the one he trusted with his hair transplant results. He was ready to play a bigger game.",
      "He visited our office and received 6,000 grafts, resulting in an amazing improvement to his hairline. Umpire Pat, with his brown hair color and brown eye color, received a ton of compliments on his new hair.",
      "With his restored confidence and hair, Pat knew his baseball umpire friends were next to take a swing at RESTORE! Enter Todd Tichenor and Dan Bellino: fellow MLB umpires who struggled with the same lack of hair and confidence. They both decided to make the call on RESTORE and have never looked back since. Dan recalls hearing the reactions from his family and friends after the procedure. \u201cI\u2019ve never felt better. I\u2019ve never looked better.\"",
    ],
    image: {
      src: "/img/r/wp-2022-09-pat-hoberg-video-bg.webp",
      alt: "Pat Hoberg hair transplant story",
    },
  },
  gallery: {
    images: [
      {
        src: "/img/r/wp-2021-12-pat-h-large-1-1-300x190.webp",
        alt: "Pat Hoberg RESTORE Client",
      },
      {
        src: "/img/r/wp-2021-12-pat-h-large-2-1-300x190.webp",
        alt: "Pat Hoberg RESTORE Client",
      },
      {
        src: "/img/r/wp-2021-12-pat-h-medium-1-1-300x275.webp",
        alt: "Pat Hoberg RESTORE Client",
      },
    ],
  },
  seo: {
    title: "Pat Hoberg Hair Transplant Results | RESTORE® Hair",
    description:
      "See MLB umpire Pat Hoberg's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.",
  },
};
